import { render } from "./SearchInvoice.vue?vue&type=template&id=520cfa6c&scoped=true"
import script from "./SearchInvoice.vue?vue&type=script&lang=js"
export * from "./SearchInvoice.vue?vue&type=script&lang=js"

import "./SearchInvoice.vue?vue&type=style&index=0&id=520cfa6c&lang=scss&scoped=true"

import exportComponent from "/root/workspace/apm-rma-frontend_iTfK/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-520cfa6c"]])

export default __exports__